// extracted by mini-css-extract-plugin
export default {"container":"Home_container__80jOb","formGroup":"Home_formGroup__GLn-D","headerImage":"Home_headerImage__Da7nk","input":"Home_input__iGwxO","aboutLink":"Home_aboutLink__GLxQ6"};